import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';

import { StoreLogo, StoreLogoVariant } from 'src/components/store-logo';
import { StoreRatingAverage } from '../store-rating-average';

import { trackShopLogoClick } from '../../tracking';

import { SHOP_LOGO_WIDTH } from 'src/areas/store/constants';

import { StoreInfo, StoreInfoTitle, FlagIcon, InfoGroup } from './styles';
import { CountryBadge } from '../stock-price-info/country-badge';

export const StoreInfoColumn: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<unknown>>
> = () => {
  const { isFeatured = false, offer } = usePriceRowContext();
  const { store, isInternationalPrice } = offer;

  if (!store) {
    return null;
  }

  const handleShopLogoClick = () => trackShopLogoClick(store.id);

  const highResolutionLogo = store.logo
    ? { url: store.logo, width: SHOP_LOGO_WIDTH }
    : null;
  return (
    <StoreInfo role="none" onClick={handleShopLogoClick}>
      <StoreInfoTitle>{store.name}</StoreInfoTitle>
      <StoreLogo
        featured={isFeatured}
        hasImage={Boolean(store.hasLogo)}
        logoUrl={highResolutionLogo?.url}
        name={store.name}
        showHighResolutionLogo={Boolean(highResolutionLogo)}
        storeId={store.id}
        variant={StoreLogoVariant.PRICE_LIST}
        width={highResolutionLogo?.width}
      />

      <InfoGroup>
        <StoreRatingAverage />
        {isInternationalPrice && store?.primaryMarket && (
          <FlagIcon>
            <CountryBadge countryCode={store.primaryMarket} />
          </FlagIcon>
        )}
      </InfoGroup>
    </StoreInfo>
  );
};
